import React from 'react';
import { Pagination as PaginationNDS, PageRange } from 'neon-design-system';

export interface PaginationProps {
  selectedRange: PageRange;
  currentPage: number;
  totalRecords: number;
  setSelectedRange: (value: PageRange) => void;
  onPageChanged: (value: number) => void;
  id?: string;
}

export const Pagination = (props: PaginationProps) => {
  const { selectedRange, currentPage, totalRecords, setSelectedRange, onPageChanged, id } = props;

  const ranges: PageRange[] = [
    { label: '15', value: 15 },
    { label: '30', value: 30 },
    { label: '50', value: 50 },
    { label: '100', value: 100 }
  ];

  return (
    <PaginationNDS
      id={id}
      ranges={ranges}
      selectedRange={selectedRange}
      currentPage={currentPage}
      maxPage={selectedRange.value === 0 ? 1 : Math.ceil(totalRecords / selectedRange.value)}
      totalRecords={totalRecords}
      recordsPerPage={selectedRange.value}
      onRangeChanged={setSelectedRange}
      onPageChanged={onPageChanged}
    />
  );
};

export default Pagination;
